import React from "react";
import HeadingText from "./Heading";
import SubheadingText from "./Subheading";
import ParagraphText from "./Paragraph";
import SplitImage from "./Split-Image";
import GalleryHorizontal from "./Gallery-Horizontal";
import { Wrapper, Break } from "../styles/components/Global/Global";
import { Lotus } from "./Lotus-Objects";
import LinkParagraphSecondary from "./Link-Paragraph-Secondary";

const SectionPixel = () => {
  const section = "pixel";
  const gallery = Lotus.galleries.find(gallery => gallery.name === section);

  return (
    <Wrapper className={`scene-switch ${section}`}>
      <Wrapper $margin>
        <HeadingText text="Pixel Paradise" />
        <LinkParagraphSecondary />
        <SubheadingText
          text="Upon entering the installation, guests are immersed in a realm where LED lights reign supreme, and those who dare to enter live peacefully under the watchful eye of a special camera which monitors the space. "
          width="medium"
          align="flex-end"
          textAlign="left"
        />
        <Break $size="medium" $mobile />
        <ParagraphText
          text="The LED lights which illuminate the exhibition play a significant role in the visual impact of the interactive piece. The special camera picks up those who walk in front of the wall of the piece, and an incredibly heightened refresh rate of the lights creates a fluid, analog-like illumination which reduces image lag to almost nothing, giving the effect of a techno-chromatic mirror."
          width="xlarge"
          size="large"
          align="flex-start"
          textAlign="left"
          zIndex={true}
        />
      </Wrapper>
      <Break $size="small" />
      <SplitImage text="In a realm where time, space, and light converge into one, Ksawery and Lotus offer those who attend the immersive exhibit a vision of a future where optimism for innovation reigns supreme. " />
      <Wrapper $margin>
        <SubheadingText
          text="“I’m very satisfied with how we pushed our system to the limits.” He notes he is particularly pleased with the unique shape of the structure, and hopes to build on his inspiration from this particular project for future ones that are even bigger, bolder, and more daring. "
          textAlign="left"
          parallax={false}
        />
      </Wrapper>
      <Break $size="small" />
      <GalleryHorizontal gallery={gallery} />
    </Wrapper>
  );
};

export default SectionPixel;
